export default __webpack_public_path__ + "static/Dallas-b981766152117b13afad1f04dca4d7d2.svg";